module.exports = __webpack_public_path__ + "img/icono_paso3.477a9856.png";